import React, { useContext } from 'react';
import { TenantListItem } from '.';
import { SuiteHeaderContext } from '../SuiteHeaderProvider';
import { ITenantProps } from './ITenantProps';
import { TenantGroup } from './TenantGroup/TenantGroup';

interface IOtherTenantsProps {
  readonly tenants: ITenantProps[];
  readonly switchTenant: (target: ITenantProps) => void;
}

export const OtherTenants: React.FC<IOtherTenantsProps> = ({ tenants, switchTenant }) => {
  const { localizationMap } = useContext(SuiteHeaderContext);
  const { otherOrganizationsTitle, organizationsEmpty } = localizationMap;
  return (
    <TenantGroup name={otherOrganizationsTitle}>
      {tenants.length > 0 ? (
        tenants.map(tenant => {
          return (
            <TenantListItem key={tenant.tenantId} item={tenant} changeTenant={switchTenant} isCurrentOrg={false} />
          );
        })
      ) : (
        <p>{organizationsEmpty}</p>
      )}
    </TenantGroup>
  );
};
